import { useContext, useState } from 'react';
import { Set_Name } from 'resolvers/Set_Name';
import { Token } from 'resolvers/Token';
import { Typography, Box, Button, Collapse, Alert, IconButton } from '@mui/material';
import { useHistory } from 'react-router';
import * as JWT from 'jsonwebtoken';
import CloseIcon from '@mui/icons-material/Close';
import ReactCodeInput from 'react-code-input';
// Our Components
import { AuthContext } from 'context/auth-context';
import { inputstyle } from './SignupComponent';
// Services
import { Auth, Login } from 'lib/api';
// Helpers
import { APP_ROUTES, LAYOUT_ROUTES } from 'routes';
import { maskEmail } from 'helpers/maskEmail';

export const SignUpSecondStep = ({ email, emailInvited, back }) => {
    const history = useHistory();
    const [secondCode, setSecondCode] = useState('');
    const [open, setOpen] = useState(false);
    const { loginUser, setDecodeState } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false);

    const verifyCode = e => {
        e.preventDefault();
        setIsLoading(true);
        let payload = {
            email: email,
            code: secondCode
        };
        if (emailInvited) {
            Login.verifyCode(payload)
                .then(response => {
                    const tokenUser = JWT.decode(response.token);
                    setDecodeState({
                        ...tokenUser,
                        loaded: true
                    });
                    loginUser(response);
                    Set_Name(response);
                    Token(response);
                    window.dataLayer.push({
                        event: 'virtual-card-signup-success'
                    });
                })
                .then(() => {
                    return history.push(LAYOUT_ROUTES.CARDS);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        }
        Auth.authActivation(payload)
            .then(response => {
                const tokenUser = JWT.decode(response.token);
                setDecodeState({
                    ...tokenUser,
                    loaded: true
                });
                loginUser(response);
                Token(response);
                window.dataLayer.push({
                    event: 'virtual-card-signup-success'
                });
            })
            .then(() => history.push(APP_ROUTES.DASHBOARD))
            .catch(() => {
                setIsLoading(false);
            });
    };

    const handleResendCodeClick = async () => {
        try {
            await Auth.resendCode({ email });
            setOpen(true);
        } catch (error) {
            console.error('ERROR:', error);
        }
    };

    return (
        <Box width="320px" marginTop="48px">
            <Box marginBottom="32px">
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        fontSize: '23px',
                        marginBottom: '9px'
                    }}>
                    Verify your identity
                </Typography>
                <Typography variant="subtitle1">
                    Open the two-factor authentication email we sent to
                    {' ' + maskEmail(email) + ' '}
                    to view your authentication code and verify your identity
                </Typography>
            </Box>
            <form noValidate onSubmit={e => verifyCode(e)}>
                <Box marginBottom="32px">
                    <ReactCodeInput
                        type="number"
                        value={secondCode}
                        onChange={setSecondCode}
                        fields={6}
                        inputStyle={inputstyle}
                    />
                </Box>

                <Button variant="contained" className="btn-rounded" fullWidth disabled={isLoading} type="submit">
                    Verify and Sign Up
                </Button>
            </form>
            <Box display="flex" flexDirection="row" justifyContent="space-evenly" marginTop="16px">
                <Typography variant="customText" onClick={back}>
                    Back
                </Typography>
                <Typography variant="customText" onClick={() => handleResendCodeClick()}>
                    Resend Code
                </Typography>
            </Box>
            <Box sx={{ width: '100%' }}>
                <Collapse in={open}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                }}>
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity="success"
                        color="info">
                        Code resent to your email
                    </Alert>
                </Collapse>
            </Box>
        </Box>
    );
};
